// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportFilterDto } from './IReportFilterDto';
import {
    IReportFilterDtoFromJSON,
    IReportFilterDtoFromJSONTyped,
    IReportFilterDtoToJSON,
    IReportFilterDtoToJSONTyped,
} from './IReportFilterDto';

/**
 * 
 * @export
 * @interface IReportSchedulerResponseDto
 */
export interface IReportSchedulerResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IReportSchedulerResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerResponseDto
     */
    report_type?: IReportSchedulerResponseDtoReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerResponseDto
     */
    report_group_type?: IReportSchedulerResponseDtoReportGroupTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerResponseDto
     */
    status?: IReportSchedulerResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerResponseDto
     */
    cron?: string;
    /**
     * 
     * @type {Date}
     * @memberof IReportSchedulerResponseDto
     */
    next_scheduled_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSchedulerResponseDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSchedulerResponseDto
     */
    end_date?: Date;
    /**
     * 
     * @type {IReportFilterDto}
     * @memberof IReportSchedulerResponseDto
     */
    report_filter?: IReportFilterDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof IReportSchedulerResponseDto
     */
    plan_names?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum IReportSchedulerResponseDtoReportTypeEnum {
    PARTICIPANT_ACCOUNT_ACTIVITY = 'PARTICIPANT_ACCOUNT_ACTIVITY',
    PAYROLL_CONTRIBUTIONS = 'PAYROLL_CONTRIBUTIONS',
    EMPLOYEE_DEMOGRAPHICS = 'EMPLOYEE_DEMOGRAPHICS',
    CLAIM_ACTIVITY = 'CLAIM_ACTIVITY',
    FORFEITURE = 'FORFEITURE',
    HEALTH_PLAN_ENROLLMENT = 'HEALTH_PLAN_ENROLLMENT',
    CARD_STATUS = 'CARD_STATUS',
    CIP_STATUS = 'CIP_STATUS',
    REPLENISHMENT_INVOICE = 'REPLENISHMENT_INVOICE',
    CONTRIBUTION_INVOICE = 'CONTRIBUTION_INVOICE',
    PREFUND_INVOICE = 'PREFUND_INVOICE',
    PLAN_OMNIBUS_BALANCE = 'PLAN_OMNIBUS_BALANCE',
    UNDELIVERABLE_ADDRESS = 'UNDELIVERABLE_ADDRESS',
    DELINQUENT_CLAIMS = 'DELINQUENT_CLAIMS'
}
/**
* @export
* @enum {string}
*/
export enum IReportSchedulerResponseDtoReportGroupTypeEnum {
    SUMMARY = 'SUMMARY',
    BREAKDOWN = 'BREAKDOWN'
}
/**
* @export
* @enum {string}
*/
export enum IReportSchedulerResponseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}


/**
 * Check if a given object implements the IReportSchedulerResponseDto interface.
 */
export function instanceOfIReportSchedulerResponseDto(value: object): value is IReportSchedulerResponseDto {
    return true;
}

export function IReportSchedulerResponseDtoFromJSON(json: any): IReportSchedulerResponseDto {
    return IReportSchedulerResponseDtoFromJSONTyped(json, false);
}

export function IReportSchedulerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSchedulerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'report_type': json['report_type'] == null ? undefined : json['report_type'],
        'report_group_type': json['report_group_type'] == null ? undefined : json['report_group_type'],
        'status': json['status'] == null ? undefined : json['status'],
        'cron': json['cron'] == null ? undefined : json['cron'],
        'next_scheduled_date': json['next_scheduled_date'] == null ? undefined : (new Date(json['next_scheduled_date'])),
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'report_filter': json['report_filter'] == null ? undefined : IReportFilterDtoFromJSON(json['report_filter']),
        'plan_names': json['plan_names'] == null ? undefined : json['plan_names'],
    };
}

export function IReportSchedulerResponseDtoToJSON(json: any): IReportSchedulerResponseDto {
    return IReportSchedulerResponseDtoToJSONTyped(json, false);
}

export function IReportSchedulerResponseDtoToJSONTyped(value?: IReportSchedulerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'report_type': value['report_type'],
        'report_group_type': value['report_group_type'],
        'status': value['status'],
        'cron': value['cron'],
        'next_scheduled_date': value['next_scheduled_date'] == null ? undefined : ((value['next_scheduled_date']).toISOString()),
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString().substring(0,10)),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString().substring(0,10)),
        'report_filter': IReportFilterDtoToJSON(value['report_filter']),
        'plan_names': value['plan_names'],
    };
}

